import { render, staticRenderFns } from "./DynamicAttributeActionDelete.vue?vue&type=template&id=5e4fc07a&"
import script from "./DynamicAttributeActionDelete.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports